import AsyncStorage from '@react-native-community/async-storage';
import * as ActionTypes from './../constants';
import axios from 'axios'; 
import {baseUrl,getUserToken } from './index'; 



const dispatchRequestUpdateProfile = updateProfileData => ({
        type:ActionTypes.REQUEST_UPDATE_PROFILE,
        updateProfileData
})

const dispatchReceivedUpdateProfile = res =>({
    type:ActionTypes.RECEIVED_UPDATE_PROFILE,
    res
})

const dispatchErrorUpdateProfile = (err) => ({
    type:ActionTypes.ERROR_UPDATE_PROFILE,
    err
})

const dispatchClearUpdateProfile= () => ({
    type: ActionTypes.CLEAR_UPDATE_PROFILE
})

export const clearUpdateProfileData = () => dispatchClearUpdateProfile();

export const updateProfile = (updateProfileData) => dispatch => {

    dispatch(dispatchRequestUpdateProfile(updateProfileData));
    delete updateProfileData.gender;
    console.log(updateProfileData, 'updated profle data');

    // const data = {
    //     first_name: 'light',
    //     last_name: 'yagami',
    //     // email: 'testmail@mail.com',
    //     city: 'warangal',
    //     address: 'mars'
    // }

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',
                url: `${baseUrl}/api/update_profile`,
                data: {...updateProfileData},
                headers: {
                    'Authorization': `Bearer ${authKey}`,
                    'Content-Type': 'application/json'
                }
            }
            // fetch(options.url, options)
            //     .then(res => res.json())
            //     .then(data =>  dispatchReceivedUpdateProfile(data))
            //     .catch(e  => dispatchErrorUpdateProfile(e));

            return axios(options)
                .then(res => dispatch(dispatchReceivedUpdateProfile(res)))
                .catch(e => dispatch(dispatchErrorUpdateProfile(e)))

        })
        .catch(e => dispatch(dispatchErrorUpdateProfile(e.response)));
}